var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWaveSquare = function SvgIconWaveSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.25 6.75a1 1 0 0 1 1-1H12a1 1 0 0 1 1 1v9.5h7.75V12a1 1 0 1 1 2 0v5.25a1 1 0 0 1-1 1H12a1 1 0 0 1-1-1v-9.5H3.25V12a1 1 0 1 1-2 0z",
    clipRule: "evenodd"
  })));
};
export default SvgIconWaveSquare;